module.exports = __webpack_public_path__ + "img/Cheese_App.45e6648a.jpg";